import { Redirect, Route, Switch, useParams, useRouteMatch } from "react-router-dom";
import { DDQueue } from "./DDQueue";
import { Wizard } from "./Wizard";

type WizardRouteParams = {
  targetId: string;
};

const WizardRoute = ({ basePath }: { basePath: string }) => {
  const { targetId } = useParams<WizardRouteParams>();
  return <Wizard targetId={targetId} basePath={basePath} />;
};

export const DdqIntake = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route exact path={path}>
        <DDQueue />
      </Route>
      <Route path={`${path}/:targetId/process`}>
        <WizardRoute basePath={path} />
      </Route>
      <Route>
        <Redirect to={path} />
      </Route>
    </Switch>
  );
};
